import React from 'react';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;

const DateFilter = ({ value, onChange }) => (
  <RangePicker
    placeholder={['Từ ngày', 'Đến ngày']}
    onChange={onChange}
    value={value}
    style={{ width: 250 }}
  />
);

export default DateFilter;
